import { render, staticRenderFns } from "./NewHotel.vue?vue&type=template&id=1dcc3690&scoped=true&"
import script from "./NewHotel.vue?vue&type=script&lang=js&"
export * from "./NewHotel.vue?vue&type=script&lang=js&"
import style0 from "./NewHotel.vue?vue&type=style&index=0&id=1dcc3690&prod&scoped=true&lang=scss&"
import style1 from "./NewHotel.vue?vue&type=style&index=1&id=1dcc3690&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc3690",
  null
  
)

export default component.exports